// Sidebar + inbox route share this hook so the inbox `useQuery` is fetched
// once per session. TanStack Query dedupes on the key, so importing this
// from both surfaces costs no extra request.
//
// Kept in its own file (rather than re-exported from `routes/inbox/inbox`)
// so the sidebar's main-bundle import doesn't pull the inbox route's heavy
// dependencies (concept-render views, katex) into the entry chunk.

import { api } from '@/lib/api';
import { useQuery } from '@tanstack/react-query';

export function useInboxStats() {
  const { data } = useQuery({
    queryKey: ['inbox'],
    queryFn: () => api.inbox(),
  });
  return data;
}
